import Select from 'admin/components/atoms/Select';
import { isEmptyObj } from 'admin/utils';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../../../hooks/useApp';
import { selectUserPrivateMoney } from '../../../../reducers/user-private-money';
import SelectedPrivateMoneyDisplay from '../../../organisms/SelectedPrivateMoneyDisplay';
import useShopSelector from '../hooks/useShopSelector';

const MySelect = styled(Select)`
  width: 300px;
  margin-right: 10px;
`;

const SenderSelector = ({
  senderOrganization,
  senderShop,
  onSelectPrivateMoney,
  onSelectOrganization,
  onSelectShop,
}) => {
  const userPrivateMoney = useAppSelector(selectUserPrivateMoney);
  const [organizationOptions, shopOptions] = useShopSelector({
    money: userPrivateMoney,
    organization: senderOrganization,
  });
  const initial = useRef(true);

  const toOption = (value) => (value && !isEmptyObj(value) ? { label: value.name, value } : null);

  useEffect(() => {
    if (!initial.current) {
      onSelectPrivateMoney(userPrivateMoney);
      onSelectOrganization({});
      onSelectShop({});
    }
    initial.current = false;
  }, [userPrivateMoney]);

  const onChangeOrganization = ({ value: organization }) => {
    onSelectOrganization(organization);
    onSelectShop({});
  };

  const onChangeShop = ({ value: shop }) => {
    onSelectShop(shop);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <SelectedPrivateMoneyDisplay />
      <MySelect
        options={organizationOptions}
        onChange={onChangeOrganization}
        placeholder="「組織」を選択"
        value={toOption(senderOrganization)}
      />
      <MySelect
        options={shopOptions}
        onChange={onChangeShop}
        placeholder="「店舗」を選択"
        value={toOption(senderShop)}
      />
    </div>
  );
};

SenderSelector.propTypes = {
  privateMoney: PropTypes.object,
  senderOrganization: PropTypes.object,
  senderShop: PropTypes.object,
  onSelectPrivateMoney: PropTypes.func,
  onSelectOrganization: PropTypes.func,
  onSelectShop: PropTypes.func,
};

SenderSelector.defaultProps = {
  privateMoney: {},
  senderOrganization: {},
  senderShop: {},
  onSelectPrivateMoney: () => {},
  onSelectOrganization: () => {},
  onSelectShop: () => {},
};

export default SenderSelector;
